export class UrlParameters {
    postCodeBegin: number;
    postCodeEnd: number;
    year: number;
    cultivationMethod: string;
    varietyIds: string;
    excludeBornholm: boolean;
}